<template>
  <div v-masonry transition-duration="0.3s" item-selector=".item">
    <div v-masonry-tile class="item" v-for="(item, index) in crList" :key="index">
      <img class="cr-img" :src="item.headImage || item.image" alt="" @click="toDetail(item.id)">
      <div class="bottom">
        <div class="cr-content">
          <div class="properties" v-if="item.properties&&item.properties.length > 0">
            <span v-for="(item, index) in item.properties" :key="index">{{ item }}</span>
          </div>
          <div class="name multiple-ellipsis">{{ item.chineseName || item.name }}</div>
        </div>
        <div class="operate-btns" v-if="item.properties&&item.properties.length > 0">
          <img v-if="item.has3d" class="custom-button" src="@/assets/images/3d-icon.png" alt="">
          <img v-if="item.hasVideo" class="custom-button" src="@/assets/images/video-icon.png" alt="">
          <img v-if="item.hasAl" class="custom-button" src="@/assets/images/other-icon.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()

const props = defineProps({
  crList: {
    type: Array,
    default: () => []
  }
})

function toDetail (id) {
  id && router.push('/crDetail/' + id)
}
</script>

<style lang="scss">
.item {
  width: 24%;
  margin-right: 1%;
}

.cr-img {
  width: 100%;
  border-radius: 5px;
  margin-bottom: 30px;
  cursor: pointer;
}

.bottom {
  display: flex;
  padding-bottom: 35px;
  position: relative;

  .cr-content {
    flex: 1;
  }

  .properties {
    font-size: 20px;
    font-weight: 300;
    color: #5A5A5A;
    line-height: 29px;

    span {
      margin-right: 15px;
      font-family: 'NotoSerifSC', system-ui;
    }
  }

  .name {
    font-size: 20px;
    font-weight: 600;
    line-height: 29px;
    -webkit-line-clamp: 1;
    font-family: 'NotoSerifSC', system-ui;
  }

  .operate-btns {
    position: absolute;
    right: 0;
    top: 7px;

    img {
      width: 20px;
      height: 20px;
      margin-right: 9px;
    }

    img:last-of-type {
      margin-right: 0;
    }
  }
}
</style>
